import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  DeleteOverrideInput,
  DeleteOverrideVariables,
  DeleteOverrideMutationResponse,
} from '../types';

const deleteOverrideMutation = gql`
  mutation DeleteOverride($input: DeleteOverrideInput!) {
    payrollDeleteOverride(input: $input) {
      code
      success
      message
      data
    }
  }
`;

export const deleteOverride = (
  input: DeleteOverrideInput,
): Promise<DeleteOverrideMutationResponse> => {
  return graphQLApi<DeleteOverrideMutationResponse, DeleteOverrideVariables>({
    query: deleteOverrideMutation,
    queryVariables: {
      input,
    },
  });
};

